import { event } from "@zillow/universal-analytics";
import { debounce } from "lodash";
const sendFieldInteractionEvent = debounce((label, blockType) => {
  const cmsInfo = {
    block_type_cd: blockType,
    block_id: "refinance_calc",
    block_displayed_txt: label
  };
  sendInteractionEvent(cmsInfo, blockType);
}, 3e3);
debounce((label, blockType) => {
  const cmsInfo = {
    block_type_cd: blockType,
    block_id: "refinance_calc",
    block_displayed_txt: label
  };
  sendInteractionClickEvent(cmsInfo);
}, 3e3);
const sendInteractionEvent = (cmsInfo, blockType) => {
  const newLaneData = {
    envelope: {
      event_type_id: "2056",
      event_type_version_id: "2",
      event_template_id: "126",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: "interaction",
      trigger_location_nm: "cms",
      trigger_source_nm: blockType === "form_field" ? "cms_form" : "cms_toggle",
      trigger_object_nm: "no_trigger_object"
    },
    semantic: {
      semantic_event_nm: "cms_engagement"
    },
    cms_info: cmsInfo
  };
  event(newLaneData);
};
const sendInteractionClickEvent = (cmsInfo) => {
  const newLaneData = {
    envelope: {
      event_type_id: "2048",
      event_type_version_id: "3",
      event_template_id: "126",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: "interaction",
      trigger_location_nm: "cms",
      trigger_source_nm: "cms_toggle",
      trigger_object_nm: "no_trigger_object"
    },
    semantic: {
      semantic_event_nm: "cms_engagement"
    },
    cms_info: cmsInfo
  };
  event(newLaneData);
};
export {
  sendFieldInteractionEvent
};
